export const toShortRevisionWear = (exterior: string): string => {
  if (exterior !== null) {
    return exterior
      .split(/-| /)
      .map((i) => i.charAt(0))
      .join('');
  }
  return '';
};
